import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, Subject, takeUntil } from 'rxjs';
import { JwtService } from '@gray/domain/http/jwt.service';
import { IsEmail } from '@gray/domain/validators/email.validator';
import { CoachAuthService } from '../../core/services/coach-auth.service';
import { CoachStateService } from '../../core/services/coach-state.service';
import { ICoach } from '../../core/models/coach.model';

@Component({
  selector: 'coach-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent implements OnDestroy {

  fg: FormGroup = this.formBuilder.group({
    email: [null, [Validators.required, IsEmail()]],
    password: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(50)]],
  });

  isLoading = false;
  isSubmitted = false;
  loginErrKey?: string;

  destroyed$ = new Subject();

  constructor(
    private formBuilder: FormBuilder,
    private coachAuthService: CoachAuthService,
    private coachState: CoachStateService,
    private jwtService: JwtService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
  }

  signIn() {
    this.isSubmitted = true;
    this.loginErrKey = undefined;

    if (this.fg.invalid) {
      return;
    }

    this.isLoading = true;
    const formVal = this.fg.value;

    this.coachAuthService.login({
      email: String(formVal.email).trim(),
      password: formVal.password,
    })
      .pipe(takeUntil(this.destroyed$), finalize(() => this.isLoading = false))
      .subscribe(r => {
        const coach = r.data.coach as ICoach;
        this.jwtService.saveToken(r.data.accessToken);
        this.coachState.setCurrentCoach(coach);

        if (this.route.snapshot.queryParams.hasOwnProperty('redirectTo')) {
          this.router.navigateByUrl(this.route.snapshot.queryParams.redirectTo);
        } else {
          this.router.navigateByUrl('/dashboard');
        }
      }, error => {
        // 403 means the account exists but its coach profile is passive — a different fix
        // for the user than wrong credentials, so it gets its own message.
        this.loginErrKey = (error?.code === 403) ? 'errors.coach_passive' : 'errors.invalid_credentials';
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
